import { FormListItem } from '../types';

type MockFormListSeed = Omit<
  FormListItem,
  'sourceTrackingEnabled' | 'publicUrl'
>;

/** Dummy list rows for Phase 1 UI / local testing (20 items). */
const MOCK_FORMS_LIST_SEED: MockFormListSeed[] = [
  {
    id: 'form_annual_2026',
    name: 'Annual fee collection 2025-2026',
    status: 'published',
    addTo: {
      mode: 'group',
      groupId: 'grp_grade8',
      groupName: 'Dance Class A'
    },
    registrationCount: 89,
    viewCount: 1247,
    conversionRate: 20,
    lastEdited: '2026-05-15T10:30:00.000Z'
  },
  {
    id: 'form_annual_2026_b',
    name: 'Annual fee collection 2025-2026',
    status: 'published',
    addTo: {
      mode: 'group',
      groupId: 'grp_grade9',
      groupName: 'Grade 9 — Evening batch'
    },
    registrationCount: 76,
    viewCount: 1102,
    conversionRate: 18,
    lastEdited: '2026-05-14T09:00:00.000Z'
  },
  {
    id: 'form_admission',
    name: 'Grade 8 admission registration',
    status: 'published',
    addTo: {
      mode: 'group',
      groupId: 'grp_admission',
      groupName: 'Admissions 2026'
    },
    registrationCount: 58,
    viewCount: 412,
    conversionRate: 14,
    lastEdited: '2026-04-25T14:00:00.000Z'
  },
  {
    id: 'form_workshop',
    name: 'Summer coding workshop',
    status: 'paused',
    addTo: { mode: 'member_list' },
    registrationCount: 23,
    viewCount: 198,
    conversionRate: 12,
    lastEdited: '2026-04-20T09:15:00.000Z'
  },
  {
    id: 'form_exam',
    name: 'Mid-term exam fee',
    status: 'closed',
    addTo: { mode: 'member_list' },
    registrationCount: 310,
    viewCount: 1200,
    conversionRate: 26,
    lastEdited: '2026-03-15T11:45:00.000Z'
  },
  {
    id: 'form_sports',
    name: 'Sports day registration',
    status: 'published',
    addTo: {
      mode: 'group',
      groupId: 'grp_sports',
      groupName: 'Sports club'
    },
    registrationCount: 45,
    viewCount: 520,
    conversionRate: 9,
    lastEdited: '2026-05-12T08:00:00.000Z'
  },
  {
    id: 'form_library',
    name: 'Library membership fee',
    status: 'paused',
    addTo: {
      mode: 'group',
      groupId: 'grp_library',
      groupName: 'Library — Main campus'
    },
    registrationCount: 12,
    viewCount: 180,
    conversionRate: 7,
    lastEdited: '2026-05-10T16:20:00.000Z'
  },
  {
    id: 'form_transport',
    name: 'School transport fee Q2',
    status: 'closed',
    addTo: { mode: 'member_list' },
    registrationCount: 201,
    viewCount: 890,
    conversionRate: 23,
    lastEdited: '2026-04-01T12:00:00.000Z'
  },
  {
    id: 'form_tuition_may',
    name: 'May tuition — Member list',
    status: 'published',
    addTo: { mode: 'member_list' },
    registrationCount: 134,
    viewCount: 980,
    conversionRate: 14,
    lastEdited: '2026-05-16T07:45:00.000Z'
  },
  {
    id: 'form_aftercare',
    name: 'After-school care enrollment',
    status: 'paused',
    addTo: {
      mode: 'group',
      groupId: 'grp_aftercare',
      groupName: 'Aftercare — Block A'
    },
    registrationCount: 31,
    viewCount: 290,
    conversionRate: 11,
    lastEdited: '2026-05-08T11:30:00.000Z'
  },
  {
    id: 'form_lab',
    name: 'Science lab kit fee',
    status: 'published',
    addTo: {
      mode: 'group',
      groupId: 'grp_science',
      groupName: 'Science — Grade 10'
    },
    registrationCount: 67,
    viewCount: 410,
    conversionRate: 16,
    lastEdited: '2026-05-11T14:10:00.000Z'
  },
  {
    id: 'form_excursion',
    name: 'Museum excursion 2026',
    status: 'closed',
    addTo: {
      mode: 'group',
      groupId: 'grp_excursion',
      groupName: 'Grade 7 excursions'
    },
    registrationCount: 88,
    viewCount: 350,
    conversionRate: 25,
    lastEdited: '2026-02-28T09:00:00.000Z'
  },
  {
    id: 'form_hostel',
    name: 'Hostel deposit — new intake',
    status: 'published',
    addTo: { mode: 'member_list' },
    registrationCount: 19,
    viewCount: 95,
    conversionRate: 20,
    lastEdited: '2026-05-13T18:00:00.000Z'
  },
  {
    id: 'form_uniform',
    name: 'Uniform order form',
    status: 'paused',
    addTo: { mode: 'member_list' },
    registrationCount: 8,
    viewCount: 140,
    conversionRate: 6,
    lastEdited: '2026-05-07T10:00:00.000Z'
  },
  {
    id: 'form_music',
    name: 'Music class — term 2',
    status: 'published',
    addTo: {
      mode: 'group',
      groupId: 'grp_music',
      groupName: 'Music elective'
    },
    registrationCount: 42,
    viewCount: 310,
    conversionRate: 14,
    lastEdited: '2026-05-09T13:25:00.000Z'
  },
  {
    id: 'form_pta',
    name: 'PTA annual contribution',
    status: 'closed',
    addTo: {
      mode: 'group',
      groupId: 'grp_pta',
      groupName: 'PTA — All parents'
    },
    registrationCount: 156,
    viewCount: 720,
    conversionRate: 22,
    lastEdited: '2026-01-20T08:30:00.000Z'
  },
  {
    id: 'form_scholarship',
    name: 'Scholarship application fee',
    status: 'paused',
    addTo: { mode: 'member_list' },
    registrationCount: 5,
    viewCount: 88,
    conversionRate: 6,
    lastEdited: '2026-05-06T15:40:00.000Z'
  },
  {
    id: 'form_canteen',
    name: 'Canteen wallet top-up',
    status: 'published',
    addTo: { mode: 'member_list' },
    registrationCount: 210,
    viewCount: 1500,
    conversionRate: 14,
    lastEdited: '2026-05-17T06:00:00.000Z'
  },
  {
    id: 'form_arts',
    name: 'Arts & crafts supplies',
    status: 'published',
    addTo: {
      mode: 'group',
      groupId: 'grp_arts',
      groupName: 'Arts — Junior wing'
    },
    registrationCount: 33,
    viewCount: 265,
    conversionRate: 12,
    lastEdited: '2026-05-04T12:15:00.000Z'
  },
  {
    id: 'form_alumni',
    name: 'Alumni meet registration',
    status: 'closed',
    addTo: { mode: 'member_list' },
    registrationCount: 94,
    viewCount: 600,
    conversionRate: 16,
    lastEdited: '2026-03-30T17:00:00.000Z'
  }
];

export const MOCK_FORMS_LIST: FormListItem[] = MOCK_FORMS_LIST_SEED.map(
  (item) => ({
    ...item,
    publicUrl: `https://forms.cofee.life/${item.id}`,
    sourceTrackingEnabled: item.status === 'published'
  })
);

export default MOCK_FORMS_LIST;
